import { all, select, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../helpers/api';
import { sendRequest } from '../../helpers/saga';
import { logger } from '../../helpers/logger';
import notifications from '../../redux/notifications/actions';
import { getHomePageGuideKey } from './helpers';

const userGuidesApi = new Api('user_guides');
const userGuidesUrlApi = new Api('user_guides/url');

function* loadContentsRequest(data) {
  try {
    let { key } = data.payload;
    const state = yield select();
    let { contents } = state.UserGuide;

    if (!contents) {
      const contentsResult = yield call(sendRequest, userGuidesApi.load, {}, notifications.REQUEST_ERROR);

      if (
        contentsResult &&
        contentsResult.data &&
        contentsResult.data.success &&
        contentsResult.data.success.data &&
        contentsResult.data.success.data.object_keys &&
        contentsResult.data.success.data.object_keys.length > 0
      ) {
        const { object_keys } = contentsResult.data.success.data;
        contents = object_keys;
      }
    }

    if (!key) {
      key = getHomePageGuideKey('dash', contents);
    }

    const signedUrlData = yield call(
      sendRequest,
      userGuidesUrlApi.multipleParamsGetRequest,
      { key: encodeURIComponent(key) },
      notifications.REQUEST_ERROR,
    );

    if (
      signedUrlData &&
      signedUrlData.data &&
      signedUrlData.data.success &&
      signedUrlData.data.success.data &&
      signedUrlData.data.success.data.url
    ) {
      const { url } = signedUrlData.data.success.data;

      // Fetch Html By Signed Url From S3
      const htmlData = yield call(fetch, url);
      const html = yield call([htmlData, htmlData.text]);

      yield put(actions.loadContentsSuccess({ contents, html }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_CONTENTS_REQUEST, loadContentsRequest)]);
}
